var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNameMerge } from '@/lib/utils';
export default function PageSection(_a) {
    var _b = _a.backgroundClass, backgroundClass = _b === void 0 ? '' : _b, children = _a.children, _c = _a.id, id = _c === void 0 ? null : _c, _d = _a.isLoading, isLoading = _d === void 0 ? false : _d, label = _a.label, _e = _a.title, title = _e === void 0 ? null : _e, _f = _a.titleClass, titleClass = _f === void 0 ? '' : _f;
    return (_jsx("section", __assign({ "aria-busy": isLoading, "aria-label": label, className: "w-full flex justify-center px-1 py-8 ".concat(backgroundClass), "data-testid": "page-section-container", role: "region" }, (id && { id: id }), { children: _jsxs("div", { className: classNameMerge('max-w-7xl w-full mx-auto p-[0.5rem] xxs:p-[1rem] md:p-[2rem] xl:p-0'), children: [title && (_jsx("div", { className: classNameMerge('mb-1', titleClass), "data-testid": "page-section-title", children: _jsx("h2", { className: "section-title", id: "page-section-title", children: title }) })), children] }) })));
}
